export default Object.freeze({
  PDF: 1,
  Word: 2,
});
